import React from 'react';
import styled from 'styled-components';
import Checkbox from '../../Checkbox/Checkbox';
import MenuItemStyled from '../../DropDown/shared/MenuItemStyled';
import { DropDownOption } from '../../DropDown/types';
import { Flex } from '../../Flex';
import OverflowTooltip from '../../OverflowTooltip';

const MenuItemWrapper = styled.div`
  padding-left: 4px;
  padding-right: 4px;
`;

const OptionContentContainer = styled(Flex)`
  align-items: center;
  overflow-x: hidden;
  width: 100%;
  gap: 8px;
  padding-right: 8px;
`;

const OptionTextContainer = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  width: 98%;
`;

interface SelectedItemProps {
  option: DropDownOption;
  optionRenderer?: (val: string) => string;
  emptyValueLabel: string;
  onClick: (e: React.MouseEvent) => void;
}

const SelectedItem = ({
  option,
  optionRenderer,
  emptyValueLabel,
  onClick,
}: SelectedItemProps) => (
  <MenuItemWrapper>
    <MenuItemStyled value={option.value} onClick={onClick} $multiple selected>
      <Checkbox checked />
      <OptionContentContainer>
        <Flex>{option.icon}</Flex>
        <OptionTextContainer>
          {optionRenderer ? (
            optionRenderer(option.value)
          ) : (
            <OverflowTooltip
              typographySx={{ maxWidth: '98%' }}
              aria-label="dropdown-option"
            >
              {option.label || emptyValueLabel}
            </OverflowTooltip>
          )}
        </OptionTextContainer>
      </OptionContentContainer>
    </MenuItemStyled>
  </MenuItemWrapper>
);

export default SelectedItem;
